import constants from '@/Constants';
import { EventReport } from '@/modules/pdf/event-report';
import { IzuReportHygiene } from '@/modules/pdf/izujapanese-hygiene';
import { IzuReportOilControl } from '@/modules/pdf/izujapanese-oil-control';
import { EventReportResponse } from '@/modules/pdf/izujapanese-oil-control/types';
import { IzuReportReceipt } from '@/modules/pdf/izujapanese-receipt';
import { IzuReportSampleRecord } from '@/modules/pdf/izujapanese-sample-record';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

export const ReportIzu: React.FC<{
  reportId: string;
  workspaceSlug: string;
}> = ({ reportId, workspaceSlug }) => {
  const [report, setReport] = useState<EventReportResponse | null>(null);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const url = constants.REPORTS_API_URL || '';

        const parsedUrl = url
          .toLowerCase()
          .replace('{{workspace}}', workspaceSlug);

        const { data, status } = await axios.get<EventReportResponse>(
          `${parsedUrl}pdf_json_by_export_id?export_id=${reportId}`,
          {
            headers: {
              Authorization: constants.REPORTS_API_AUTHORIZATION_TOKEN,
            },
          },
        );

        if (status === 200) {
          setReport(data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchReport();
  }, [reportId, workspaceSlug]);

  if (report?.body && report.body[0].form_name.includes('Controle do Óleo')) {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <IzuReportOilControl
          reportData={{
            body: {
              items: report?.body || [],
            },
            header: report?.header,
          }}
        />
      </div>
    );
  }

  if (
    report?.body &&
    report.body[0].form_name.includes('Recebimento de Mercadorias')
  ) {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <IzuReportReceipt
          reportData={{
            body: {
              items: report?.body || [],
            },
            header: report?.header,
          }}
        />
      </div>
    );
  }

  if (
    report?.body &&
    report.body[0].form_name.includes('Registro de Amostras')
  ) {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <IzuReportSampleRecord
          reportData={{
            body: {
              items: report?.body || [],
            },
            header: report?.header,
          }}
        />
      </div>
    );
  }

  if (
    report?.body &&
    report.body[0].form_name.includes('Registro Diário de Higienização')
  ) {
    return (
      <div style={{ height: '100%', width: '100%' }}>
        <IzuReportHygiene
          reportData={{
            body: {
              items: report?.body || [],
            },
            header: report?.header,
          }}
        />
      </div>
    );
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <EventReport
        reportData={{
          body: {
            items: report?.body || [],
          },
          header: report?.header,
        }}
      />
    </div>
  );
};
